import { default as Modal } from "./ModalContractor";
import { Store, StoreContext, useStore } from "./store";

export default {
  Store,
  StoreContext,
  useStore,
  Modal,
};
